<template>
  <div class="form-container step2">
    <div class="loader" v-if="isLoading"></div>
    <form id="topup-phone-step2" @submit.prevent="submit">
      <div class="form-row" v-if="topupError">
        <div class="d-error">
          <h1>Podczas przetwarzania doładowania wystapił błąd!</h1>
          <p>Spróbuj ponownie lub skonsultuj się z pomocą techniczną.</p>
        </div>
      </div>
      <div class="rel">
        <div class="form-row" :class="{error: form.isSubmited && !form.isAmountValid}">
          <div class="d-flex">
            <label for="topup-amount">Kwota doładowania: <span class="red">*</span></label>
            <div>
              <input type="text"
                     v-model="form.data.amount"
                     id="topup-amount"
                     v-if="isOperatorTopupAmountTypeAny(operator)"
                     @change="checkAmount" />
              <select name="topup-amount"
                      id="topup-amount"
                      v-model="form.data.amount"
                      v-if="isOperatorTopupAmountTypeList(operator)"
                      @change="checkAmount">
                <option value="">- wybierz -</option>
                <option v-for="value in getOperatorTopupAmountList(operator)" :key="value" :value="value">{{ value }}</option>
              </select>
              <span class="suffix">PLN</span>
            </div>
          </div>
          <div class="error" v-if="form.isSubmited && !form.isAmountValid">Podaj kwotę doładowania</div>
        </div>
        <div class="form-row" :class="{error: form.isSubmited && !form.isPhoneValid}">
          <div class="d-flex">
            <label for="topup-phone">Numer telefonu: <span class="red">*</span></label>
            <div>
              <input type="tel" v-model="form.data.phone"
                     id="topup-phone"
                     maxlength="11"
                     @keyup="formatPhone"
                     @change="checkPhone"
                     :disabled="form.isPhoneCheckInProgess" />
              <span class="suffix" v-if="form.isPhoneCheckInProgess">
            <i class="el-icon-loading"></i>
          </span>
            </div>
          </div>
          <div class="error" v-if="form.isSubmited && !form.isPhoneValid">Podaj poprawny numer telefonu</div>
        </div>
        <div class="form-row" :class="{error: form.isSubmited && !form.isEmailValid}">
          <div class="d-flex">
            <label for="topup-email">Adres e-mail: <span class="red">*</span></label>
            <div>
              <input type="email" v-model="form.data.email" id="topup-email" @change="checkEmail" />
              <span class="suffix">
            <el-tooltip content="Na ten adres zostanie przesłane potwierdzenie transakcji." placement="top" :hide-after="1000">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
            </div>
          </div>
          <div class="error" v-if="form.isSubmited && !form.isEmailValid">Podaj poprawny adres e-mail</div>
        </div>
        <div class="form-row consents">
          <h3>Zgody i oświadczenia</h3>
        </div>
        <div class="form-row d-checkbox check-all">
          <div class="with-checkbox">
            <input type="checkbox" id="check-all" v-model="checkAll">
            <label for="check-all">
              <div class="mark"></div>
              <div class="text">
                <span class="check-all">Zaznacz wszystkie</span>
              </div>
            </label>
          </div>
        </div>
        <div class="form-row d-checkbox" :class="{error: form.isSubmited && !form.data.terms}">
          <div class="with-checkbox">
            <input type="checkbox" id="terms" v-model="form.data.terms">
            <label for="terms">
              <div class="mark"></div>
              <div class="text">
                <p>Oświadczam że: <span class="red">*</span></p>
                Zapoznałem się i akceptuję <a href="/files/doladujtutaj/Regulamin-doladowan-doladujtutaj.pdf" target="_blank">Regulamin usługi</a> natychmiastowego doładowania telefonu oraz <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Politykę prywatności</a>.
                Chcę, aby usługa była wykonana niezwłocznie i wiem, że nie otrzymam zwrotu poniesionych kosztów w przypadku odstąpienia od umowy.
                Jestem rezydentem Rzeczypospolitej Polskiej.
              </div>
            </label>
          </div>
          <div class="error" v-if="form.isSubmited && !form.data.terms">Pole wymagane</div>
        </div>
        <div class="form-row d-checkbox">
          <div class="with-checkbox">
            <input type="checkbox" id="marketing" v-model="form.data.marketing">
            <label for="marketing">
              <div class="mark"></div>
              <div class="text">
                <p class="not-required">Zgoda nieobowiązkowa</p>
                <p>
                  Czy chcesz otrzymywać od nas mailowe, SMSowe lub telefoniczne powiadomienia o najlepszych ofertach<span v-if="!form.showMarketing">? <a class="toggle-more" href="" @click.prevent="form.showMarketing = true">więcej</a></span>
                  <span v-if="form.showMarketing">, promocjach, konkursach i innych ciekawych wydarzeniach organizowanych przez nas lub naszych Partnerów? Obiecujemy nie spamować! Jeżeli nasze wiadomości Ciebie znudzą, w każdej chwili możesz wycofać zgodę.
                  <span><a href="" @click.prevent="form.showMarketing = false">mniej</a></span>
                </span>
                </p>
              </div>
            </label>
          </div>
        </div>
        <div class="form-row d-checkbox">
          <div class="with-checkbox">
            <input type="checkbox" id="partner" v-model="form.data.partner">
            <label for="partner">
              <div class="mark"></div>
              <div class="text">
                <p class="not-required">Zgoda nieobowiązkowa</p>
                <p>
                  Czy chcesz abyśmy mogli przekazać naszym zaufanym Partnerom Twój email lub telefon<span v-if="!form.showPartner">? <a class="toggle-more" href="" @click.prevent="form.showPartner = true">więcej</a></span>
                  <span v-if="form.showPartner">, aby mogli Tobie przedstawiać ciekawe informacje i oferty? Zapewniamy, że grono naszych Partnerów to uznane firmy, które tak jak my nie lubią spamować, a zgodę możesz w każdej chwili odwołać.
                  <span><a href="" @click.prevent="form.showPartner = false">mniej</a></span>
                </span>
                </p>
              </div>
            </label>
          </div>
        </div>
        <div class="form-row d-info d-frame">
          <i class="info"></i>
          <span class="bold">Faktura za doładowanie</span><br>
          Aby otrzymać fakturę VAT za doładowanie telefonu należy zarejestrować się pod adresem: <a href="https://faktury.autopay.pl" target="_blank">https://faktury.autopay.pl</a> w ciągu 7 dni od momentu wykonania doładowania.
          Jeżeli dane wraz z doładowywanym numerem zostały zarejestrowane, faktura VAT zostanie dostarczona na wskazany adres e-mail w ciągu 24 godzin.
        </div>
        <div class="form-row">
          <span class="red">*</span> pole wymagane
        </div>
        <div class="form-row form-buttons justify-content-between">
          <button type="button" class="btn btn-back" @click="goBack" :disabled="form.isPhoneCheckInProgess || isLoading">Wstecz</button>
          <button type="submit" class="btn" :disabled="form.isPhoneCheckInProgess || isLoading">Akceptuję i płacę</button>
        </div>
        <administrator-data-info />
        <div class="operator">
          <img :src="getOperatorLogoSrc(operator)" :alt="operator">
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import OperatorMixin from '@/doladujtutaj/mixins/operator.mixin'
import { mapActions, mapMutations, mapState } from 'vuex'
import { ToolsClass } from '@/common/class/tools.class'
import { TOPUP_PHONE_WITHOUT_PREFIX_LENGTH, TOPUP_RESPONSE_SUCCESS } from '@/common/const/topup.const'
import AdministratorDataInfo from '@/doladujtutaj/components/AdministratorDataInfo'

export default {
  name: 'TopupPhoneStep2',
  components: { AdministratorDataInfo },
  mixins: [OperatorMixin],
  computed: {
    ...mapState({
      operator: state => state.topup.data.operator,
      isLoading: state => state.topup.loading
    }),
    checkAll: {
      get () {
        return this.form.data.terms && this.form.data.marketing && this.form.data.partner
      },
      set (value) {
        this.form.data.terms = value
        this.form.data.marketing = value
        this.form.data.partner = value
      }
    }
  },
  data () {
    return {
      topupError: false,
      form: {
        data: {
          amount: '',
          phone: null,
          email: null,
          terms: false,
          marketing: false,
          partner: false
        },
        isAmountValid: false,
        isPhoneValid: false,
        isPhoneCheckInProgess: false,
        isEmailValid: false,
        isSubmited: false,
        showMore: false,
        showMarketing: false,
        showPartner: false
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_TOPUP_STAGE',
      'SET_TOPUP_LOADING'
    ]),
    ...mapActions([
      'checkPhoneStatus',
      'sendTopup'
    ]),
    checkAmount () {
      let amount = parseInt(this.form.data.amount, 10)
      if (!amount || isNaN(amount)) {
        this.form.isAmountValid = false
        return
      }

      if (this.isOperatorTopupAmountTypeList(this.operator)) {
        const allowedAmounts = this.getOperatorTopupAmountList(this.operator)
        if (allowedAmounts.indexOf(amount) === -1) {
          this.form.data.amount = ''
          this.form.isAmountValid = false
          return
        }
      }

      if (this.isOperatorTopupAmountTypeAny(this.operator)) {
        const amountMin = this.getOperatorTopupAmountMin(this.operator)
        const amountMax = this.getOperatorTopupAmountMax(this.operator)
        if (amount < amountMin) {
          this.form.data.amount = amountMin
          this.form.isAmountValid = true
          return
        }
        if (amount > amountMax) {
          this.form.data.amount = amountMax
          this.form.isAmountValid = true
          return
        }
      }

      this.form.data.amount = amount
      this.form.isAmountValid = true
    },
    checkEmail () {
      let email = this.form.data.email
      if (!email || !email.length) {
        this.form.isEmailValid = false
        return
      }
      if (!ToolsClass.isEmailValid(email)) {
        this.form.isEmailValid = false
        return
      }
      this.form.isEmailValid = true
    },
    formatPhone () {
      this.form.data.phone = String(this.form.data.phone).replace(/[^0-9]/g, '')
    },
    checkPhone () {
      let phone = String(this.form.data.phone)
      this.form.isPhoneCheckInProgess = false

      // czy numer pusty
      if (!phone || !phone.length) {
        this.form.isPhoneValid = false
        return
      }

      // czy numer ma dobrą długość
      if (ToolsClass.cleanPhoneNumber(phone).length < TOPUP_PHONE_WITHOUT_PREFIX_LENGTH) {
        this.form.isPhoneValid = false
        return
      }
      // czy numer jest prawidłowy
      if (!ToolsClass.isPhoneNumberValid(phone)) {
        this.form.isPhoneValid = false
        return
      }
      this.form.isPhoneValid = false

      // checkphone w backendzie
      this.form.isPhoneCheckInProgess = true
      let data = {
        operator: this.getOperatorValue(this.operator),
        account: `48${ToolsClass.cleanPhoneNumber(phone)}`,
        amount: 5.00
      }
      this.checkPhoneStatus(data)
        .then(response => {
          this.form.isPhoneValid = response.body.status === 1
        })
        .catch(() => {
          this.form.isPhoneValid = false
        })
        .finally(() => {
          this.form.isPhoneCheckInProgess = false
        })
    },
    isPhoneValid () {},
    isEmailValid () {},
    isFormValid () {
      return this.form.isAmountValid &&
        this.form.isPhoneValid &&
        this.form.isEmailValid &&
        this.form.data.terms
    },
    goBack () {
      this.SET_TOPUP_STAGE(1)
    },
    scrollToLoader () {
      setTimeout(() => {
        ToolsClass.scrollToElement(document.querySelector('.loader'), -120, 'smooth')
      }, 100)
    },
    scrollToError () {
      setTimeout(() => {
        ToolsClass.scrollToElement(document.querySelector('.form-row.error'), -120, 'smooth')
      }, 100)
    },
    submit () {
      this.form.isSubmited = true
      this.topupError = false
      if (!this.isFormValid()) {
        this.scrollToError()
        return false
      }

      const data = {
        products: [{
          account: `48${ToolsClass.cleanPhoneNumber(this.form.data.phone)}`,
          amount: this.form.data.amount,
          operator: this.getOperatorValue(this.operator)
        }],
        email: this.form.data.email,
        language: 'PL'
      }
      this.SET_TOPUP_LOADING(true)
      this.scrollToLoader()
      this.sendTopup(data)
        .then(response => {
          if (response.body.status === TOPUP_RESPONSE_SUCCESS && response.body.paymentLink) {
            window.parent.location.href = response.body.paymentLink
            return
          }

          this.SET_TOPUP_LOADING(false)
          this.topupError = true
        })
        .catch(() => {
          this.SET_TOPUP_LOADING(false)
          this.topupError = true
        })
    }
  },
  updated () {
    ToolsClass.sendHeightToIframeParent()
  }
}
</script>
